import { callApi } from 'modules/core/api/services'

export const eventCheckoutProduct = (eventUuid: string, productUuid: string) =>
  callApi(`/v2/events/${eventUuid}/checkout/${productUuid}`)
